export const hasRight = (userObj, moduleKey, action = null) => {
    if (!userObj) return false;

    // 1. Super Admin : Accès total
    if (userObj.role === 'super_admin') return true;

    // 2. Admin : Accès total sauf gestion des utilisateurs
    if (userObj.role === 'admin') {
        return moduleKey !== 'users';
    }

    // 3. Simple Utilisateur : Analyse sécurisée des droits
    let rights = userObj.rights;

    // SÉCURITÉ : Si les droits arrivent sous forme de chaîne JSON, on les décode
    if (typeof rights === 'string') {
        try {
            rights = JSON.parse(rights);
        } catch (e) {
            return false;
        }
    }

    const safeRights = rights || { crud: {}, modules: {} };

    if (action) {
        // On s'assure que moduleKey est bien au pluriel pour correspondre à la matrice
        const normalizedKey = moduleKey === 'property' ? 'properties' : moduleKey;
        const moduleRights = safeRights.crud ? safeRights.crud[normalizedKey] : [];
        return Array.isArray(moduleRights) && moduleRights.includes(action);
    } else {
        const hasModuleAccess = safeRights.modules ? safeRights.modules[moduleKey] : false;
        return hasModuleAccess === true;
    }
};